module.exports = __webpack_public_path__ + "img/big.a5f82258.jpg";